import React from 'react';
import moment from 'moment';
import { isWorkShift } from '../utils';

const SummaryRow = ({ schedule, weekDates }) => (
    <tr className="sumrow">
        <td className="namecell">Смена</td>
        {weekDates.map((date) => {
            const dateStr = moment(date).format('YYYY-MM-DD');
            const fact = (schedule || []).reduce((count, shift) => {
                if (!shift.schedules || !shift.schedules.length) return count;
                if (moment(shift.schedules[0].date).format('YYYY-MM-DD') !== dateStr) return count;
                return count + (isWorkShift(shift) ? 1 : 0);
            }, 0);
            return (
                <td key={dateStr} className="pc-sched-cov">
                    <b>{fact}</b>
                </td>
            );
        })}
        <td />
    </tr>
);

export default SummaryRow;
